export default {"src":"/_next/static/media/instagram.40cd18de.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};